import React, { useEffect, useState } from 'react';
import { Button, Col, Input, Popover, Radio, Row, Tabs } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import LoanTabDatas from './LoanTabDatas';
import '../../assets/Custom.css';
import SwitchBox from './SwitchBox';
import SortBy from './SortBy';
import CaseTabDetails from './CaseTabDetails';
import { useLocation, useNavigate } from 'react-router-dom';
import { ServerAPI } from '../../common/ServerAPI';
import moment from 'moment';
import { ReactComponent as BackIcon } from '../../images/back.svg';
import { isDisabled } from '@testing-library/user-event/dist/utils';

const CaseDetails = () => {
  const [formType, setFormType] = useState('loan');
  // const [activeKeyData, setActiveKeyData] = useState('');
  const [caseDetails, setCaseDetails] = useState({});
  const location = useLocation();
  const applicationId = location.state?.Id;
  const pagePermission = location.state?.pagePermission;
  //console.log('LOCATION', caseDetails);

  useEffect(() => {
    if (applicationId !== null && applicationId !== undefined) {
      localStorage.setItem('applicationId', applicationId);
    }
  }, [applicationId]);
  //console.log(applicationId);

  const navigate = useNavigate();
  const [activeKey, setActiveKey] = useState('1');
  const onChange = (tabValue) => {
    if (tabValue == '1') {
      setFormType('loan');
    } else if (tabValue == '2') {
      setFormType('vehicle');
    } else if (tabValue == '3') {
      setFormType('applicant');
    } else if (tabValue == '4') {
      setFormType('guarantor');
    } else if (tabValue == '5') {
      setFormType('dealer');
    } else if (tabValue == '6') {
      setFormType('disbursement');
    }
    setActiveKey(tabValue);
    localStorage.setItem('tabValue', tabValue);
  };

  const handleSortBy = (val) => {
    switch (val) {
      case 'Most Recent':
        break;
      case 'Name A-Z':
        break;
      case 'Name Z-A':
        break;
      default:
        break;
    }
  };

  const items = [
    {
      label: 'Application Details',
      key: '1',
      children: '',
    },
    {
      label: 'Vehicle Details',
      key: '2',
      children: '',
    },
    {
      label: 'Applicant Details',
      key: '3',
      children: '',
    },
    {
      label: 'Guarantors',
      key: '4',
      children: '',
    },
    {
      label: 'Dealer Details',
      key: '5',
      children: '',
    },
    {
      label: 'Disbursement',
      key: '6',
      children: '',
    },
  ];

  const applicationDetails = async () => {
    const response = await ServerAPI.applicationInfo();
    if (response.data) {
      setCaseDetails(response.data);
    }
  };

  useEffect(() => {
    let previousTabValue = localStorage.getItem('tabValue');
    if (previousTabValue) {
      setActiveKey(previousTabValue);
    } else {
      setActiveKey('1');
    }
    if (previousTabValue == '1') {
      setFormType('loan');
    } else if (previousTabValue == '2') {
      setFormType('vehicle');
    } else if (previousTabValue == '3') {
      setFormType('applicant');
    } else if (previousTabValue == '4') {
      setFormType('guarantor');
    } else if (previousTabValue == '5') {
      setFormType('dealer');
    } else if (previousTabValue == '6') {
      setFormType('disbursement');
    }
    applicationDetails();
  }, [location]);
  useEffect(() => {
    let previousTabValue = localStorage.getItem('tabValue');
    if (previousTabValue) {
      setActiveKey(previousTabValue);
    } else {
      setActiveKey('1');
    }
    if (previousTabValue == '1') {
      setFormType('loan');
    } else if (previousTabValue == '2') {
      setFormType('vehicle');
    } else if (previousTabValue == '3') {
      setFormType('applicant');
    } else if (previousTabValue == '4') {
      setFormType('guarantor');
    } else if (previousTabValue == '5') {
      setFormType('dealer');
    } else if (previousTabValue == '6') {
      setFormType('disbursement');
    }
    applicationDetails();
  }, []);
  const isDibursed = caseDetails?.disbursementinfo !== null && caseDetails?.disbursementinfo !== undefined ? true : false

  //console.log('caseDetails', caseDetails)
  return (
    <div className='w-full min-h-screen bg-[#F5F5F5] overflow-x-clip'>
      <section className='common_container'>
        <header className='common-header flex justify-between flex-wrap gap-4'>
          <div className='common-header-body'>
            <h1 className=' flex items-center gap-3 flex-wrap'>
              <span className='cursor-pointer' onClick={() => navigate(-1)}>
                <BackIcon />
              </span>
              Loan Application Cases
              <Button
                type='submit'
                className='sav_btn'
                onClick={() => {
                  navigate('/case-summary');
                }}
              >
                Case Summary
              </Button>
            </h1>
            {!isDibursed && (
              <div className='cases-publish'>
                <h2>
                  Publish on:{' '}
                  <span>
                    {moment(caseDetails.created_at).format('DD MMM YYYY, HH:MM')}
                  </span>
                </h2>
                <h2>
                  Case Expiry:{' '}
                  <span>
                    {moment(caseDetails.expired_at).format('DD MMM YYYY, HH:MM')}
                  </span>
                </h2>
              </div>
            )}
          </div>
        </header>
        <div className='app-container p-[0px_25px] bg-white'>
          <Tabs
            onChange={onChange}
            defaultActiveKey={activeKey}
            activeKey={activeKey}
            items={caseDetails?.user_type == 1 ? items : items?.filter((it) => it?.label !== "Dealer Details")}
            tabBarExtraContent={
              <div className='max-[768px]:mt-1 min-[768px]:text-right ml-2'>
                Credit(s):{' '}
                <span className='text-[#0660FC]'>
                  5000
                  <Popover content={'Coming soon'} className='mt-[-4px]'>
                    <img
                      src='/images/fi_info.svg'
                      alt='info'
                      className='inline-block ml-[8px] cursor-pointer'
                    />
                  </Popover>
                </span>
              </div>
            }
          ></Tabs>
        </div>
        <CaseTabDetails
          type={formType}
          data={caseDetails}
          reloadData={applicationDetails}
          pagePermission={pagePermission}
          tabChange={onChange}
          isDibursed={isDibursed}
        />
      </section>
    </div>
  );
};

export default CaseDetails;
